import { ScenarioCategory } from '../model/scenario-category.model'
import { ScopeConfiguration } from '@app/core/model/scope-version'

export const getConfigurationWithEmptyAnswerValues = (
  category: ScenarioCategory,
  scopeConfiguration: ScopeConfiguration
) => {
  const configuration = { ...scopeConfiguration }

  category.questions.forEach((q) => {
    if (!configuration[category.id]?.hasOwnProperty(q.id))
      configuration[category.id] = { ...configuration[category.id], [q.id]: null }

    if (configuration[category.id][q.id] === '') configuration[category.id][q.id] = null
  })

  return configuration
}
